module.exports = __webpack_public_path__ + "7c0691e08cbafff8750b39324bc09d22.png";